import {Component, Input, OnChanges} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {
  FloatingMenuActionsEnum,
  FloatingMenuService,
  IFloatingMenuData,
} from 'app/common/services/floating-menu.service';
import {AnimationOptions, LottieComponent} from 'ngx-lottie';
import {SharedModule} from 'app/shared/shared.module';

@Component({
  selector: 'floating-actions',
  templateUrl: './floating-actions.component.html',
  styleUrls: ['./floating-actions.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    LottieComponent,
  ],
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
  host: { '[@fadeAnimation]': '' },
})
export class FloatingActionsComponent implements OnChanges {
  @Input() buttonLeftPosition: string;
  @Input() actionsMenuState: IFloatingMenuData;

  FloatingMenuActionsEnum = FloatingMenuActionsEnum;
  lottieOptions: AnimationOptions = {
    path: '/assets/files/lottie-star-loader.json',
    loop: true,
    autoplay: true,
  };
  hasAnyActiveCompetitor: boolean = false;
  hasAnyNotActiveCompetitor: boolean = false;

  constructor(private floatingMenuService: FloatingMenuService,
  ) {
  }

  ngOnChanges(): void {
    this.hasAnyActiveCompetitor = this.actionsMenuState.selectedCompetitors?.some(comp => comp.isActive);
    this.hasAnyNotActiveCompetitor = this.actionsMenuState.selectedCompetitors?.some(comp => !comp.isActive);
  }

  emitAction(action: FloatingMenuActionsEnum): void {
    this.floatingMenuService.floatingMenuActionEvent$.next(action);
  }
}
